export class SentactFeedbackError extends Error {
    constructor(message) {
        super(message);
    }
}
